<div class="title">{{ contactData && contactData.displayName }}</div>

<contact-info [contactData]="contactData"></contact-info>

<button class="edit" (click)="emClick.emit($event)">
	{{ 'SESSION.USERINFO.EDIT' | translate }}
</button>

<div class="info-message" *ngIf="incompleteData">
	<span class="freud-icon freud-icon-xs freud-icon-info-circle"></span>
	<p>{{ 'SESSION.USERINFO.INCOMPLETE_DATA_WARN' | translate }}</p>
</div>
